"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GatherPromise = void 0;
const missing_1 = require("./missing");
/**
 * Similar to Promise.all, but can outputs more than one error as an array
 */
async function GatherPromise(promises) {
    const rawResults = await Promise.allSettled(promises);
    const rejects = rawResults
        .map((r) => (r.status === 'rejected' ? r.reason : missing_1.missing))
        .filter(missing_1.isNotMissing);
    if (rejects.length) {
        throw rejects;
    }
    const resolves = rawResults
        .map((r) => (r.status === 'fulfilled' ? r.value : missing_1.missing))
        .filter(missing_1.isNotMissing);
    return resolves;
}
exports.GatherPromise = GatherPromise;
//# sourceMappingURL=GatherPromise.js.map